import { gql } from '@apollo/client';
import { genericFields } from './index';

export const bookmarksFragment = gql`
  fragment bookmarksItemFields on Item {
    ${genericFields}
    photos(limit: 4) {
      thumbnail
      f460x345
      large
    }
  }
`;
